import realpressAgentList from './agent-list/agent-list';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressAgentList();
} );
